import styled from 'styled-components';

export const PopupText = styled.p`
  color: #555;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.266667px;
`;
